import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const AlertModel = ({ isOpen, onConfirm, onCancel }) => (
    <Modal show={isOpen} onHide={onCancel}>
        <Modal.Header closeButton>
            <Modal.Title className='text-primary'>Unsaved Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body className='text-danger'>
            <h6>
                You have unsaved changes. Are you sure you want to leave without saving?
            </h6>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onCancel}>
                Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm}>
                Confirm
            </Button>
        </Modal.Footer>
    </Modal>
);

export default AlertModel;